import React, { useState, useEffect } from "react";
import { TOKENS } from "../tokens";
import { Card } from "./Card";
import api from "../api/client";
import { Star, TrendingUp, AlertTriangle } from "lucide-react";

export function PerformanceDashboard({ emp }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchScore = async () => {
      try {
        const res = await api.get(`/pi/monthly/${emp.id || emp.employee_id}`);
        if (isMounted) setData(res.data);
      } catch (err) {
        console.error("Failed to load PI:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    if (emp && (emp.id || emp.employee_id)) {
      fetchScore();
    }
  }, [emp]);

  if (loading) return <Card style={{ padding: 18, marginTop: 16 }}><div style={{ color: TOKENS.muted, fontSize: 13 }}>Loading Performance Data...</div></Card>;
  if (!data || !data.data) return <Card style={{ padding: 18, marginTop: 16 }}><div style={{ color: TOKENS.muted, fontSize: 13 }}>No performance data available for this month.</div></Card>;

  const { pi_score, w_attendance, w_tasks, w_reports } = data.data;

  let grade = "D";
  let action = "PIP, no variable pay";
  let badgeBg = "#FEE2E2"; let badgeColor = "#991B1B"; let badgeBorder = "#EF4444";

  if (pi_score >= 90) {
    grade = "A+"; action = "Top 10% pool eligible";
    badgeBg = "#FEF3C7"; badgeColor = "#B45309"; badgeBorder = "#F59E0B";
  } else if (pi_score >= 80) {
    grade = "A"; action = "Meets expectations";
    badgeBg = "#DBEAFE"; badgeColor = "#1E40AF"; badgeBorder = "#3B82F6";
  } else if (pi_score >= 70) {
    grade = "B"; action = "Coaching required";
    badgeBg = "#E0E7FF"; badgeColor = "#3730A3"; badgeBorder = "#6366F1";
  } else if (pi_score >= 60) {
    grade = "C"; action = "Improvement plan";
    badgeBg = "#FFEDD5"; badgeColor = "#C2410C"; badgeBorder = "#F97316";
  }

  return (
    <Card style={{ padding: 18, marginTop: 16, background: `linear-gradient(135deg, #ffffff, ${TOKENS.cream})`, border: `1.5px solid ${badgeBorder}50` }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            padding: "6px 14px", borderRadius: 12, background: badgeBg, color: badgeColor,
            border: `1.5px solid ${badgeBorder}`, fontSize: 18, fontWeight: 900, fontFamily: "Fraunces, serif"
          }}>
            Grade {grade}
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: TOKENS.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>Month-to-Date PI</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: TOKENS.navyDeep }}>{Number(pi_score).toFixed(1)}%</div>
          </div>
        </div>

        <div style={{
          padding: "6px 12px", borderRadius: 10, background: badgeBg, color: badgeColor,
          fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6
        }}>
          <Star size={14} fill={badgeColor} color={badgeColor} />
          <span>{action}</span>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginTop: 12, paddingTop: 12, borderTop: `1px solid ${TOKENS.border}` }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: TOKENS.muted }}>ATTENDANCE (40%)</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: TOKENS.ink }}>{Number(w_attendance).toFixed(1)} / 40</div>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: TOKENS.muted }}>TASKS (40%)</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: TOKENS.ink }}>{Number(w_tasks).toFixed(1)} / 40</div>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: TOKENS.muted }}>REPORTS (20%)</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: TOKENS.ink }}>{Number(w_reports).toFixed(1)} / 20</div>
        </div>
      </div>
      <div style={{ marginTop: 12, fontSize: 11, color: TOKENS.muted, display: "flex", alignItems: "center", gap: 4 }}>
        <TrendingUp size={12} />
        Performance is calculated nightly based on verified GPS check-ins, tasks done vs assigned, and daily reports.
      </div>
    </Card>
  );
}
